import { LOCALE_LABELS, SUPPORTED_LOCALES } from "@/definition/constants";
import { getSavedLocale, isSupportedLocale, setI18nLocale } from "@/utils/i18n";

const initialLocale = getSavedLocale();

const state = {
  locale: initialLocale,
  locales: SUPPORTED_LOCALES,
  localeLabels: LOCALE_LABELS,
};

const getters = {
  // eslint-disable-next-line no-shadow
  locale: (state) => state.locale,
  // eslint-disable-next-line no-shadow
  locales: (state) => state.locales,
  // eslint-disable-next-line no-shadow
  localeLabels: (state) => state.localeLabels,
};

const mutations = {
  setLocale: (state, value) => {
    if (!isSupportedLocale(value)) return;

    state.locale = value;
    setI18nLocale(value);
  },
};

const actions = {
  changeLocale({ commit }, locale) {
    commit("setLocale", locale);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
